module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/chevron-left-small-5c33b21f6665215a5a001ffe4efb6c35.svg";